import React, { useContext, useEffect } from 'react';
import { BrowserRouter as Router, Redirect, Route, Switch, useLocation } from 'react-router-dom';
import AboutUs from './components/AboutUs';
import BusinessClosuresPage from './components/BusinessClosuresPage';
import Checkout from './components/Checkout';
import ContactUs from './components/ContactUs';
import DriverOrders from './components/DriverOrders';
import Footer from './components/Footer';
import HomePage from './components/HomePage';
import Kitchen from './components/Kitchen';
import Navbar from './components/Navbar';
import OrderConfirmation from './components/OrderConfirmation';
import Orders from './components/Orders';
import RegisterForm from './components/RegisterForm';
import SignInForm from './components/SignInForm';
import TermsAndConditions from './components/TermsAndConditions';
import UpdateMenuPage from './components/UpdateMenuPage';
import SoldOutPage from './components/SoldOutPage';
import { AuthContext, AuthProvider } from './contexts/AuthContext';
import { BasketProvider } from './contexts/BasketContext';
import { BusinessStatusProvider } from './contexts/BusinessStatusContext';
import './App.css';

function PageTracker() {
    const location = useLocation();
    useEffect(() => {
        document.title = location.pathname === '/' ? 'Divine Veg on 262' : 'Divine Veg on 262 | Order online';
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }, [location.pathname]);
    return null;
}

function AppRoutes() {
    const { user, authLoading } = useContext(AuthContext);
    const isAdmin = ['admin', 'superadmin'].includes(user?.role);
    const isDriver = user?.role === 'driver';

    if (authLoading) return <div className="route-loading-state">Loading Divine Veg...</div>;

    if (isDriver) {
        return <div className="App"><PageTracker /><Navbar /><Switch><Route path="/driver-orders" component={DriverOrders} /><Redirect to="/driver-orders" /></Switch></div>;
    }

    return (
        <div className="App">
            <PageTracker />
            <Navbar />
            <Switch>
                <Route exact path="/" component={HomePage} />
                <Route path="/checkout" component={Checkout} />
                <Route path="/order-confirmation/:orderId?" component={OrderConfirmation} />
                <Route path="/about-us" component={AboutUs} />
                <Route path="/contact-us" component={ContactUs} />
                <Route path="/terms-and-conditions" component={TermsAndConditions} />
                <Route path="/sign-in" component={SignInForm} />
                <Route path="/register" component={RegisterForm} />
                <Route path="/orders" component={Orders} />
                {isAdmin && <Route path="/kitchen" component={Kitchen} />}
                {isAdmin && <Route path="/driver-orders" component={DriverOrders} />}
                {isAdmin && <Route path="/update-menu" component={UpdateMenuPage} />}
                {isAdmin && <Route path="/menu-availability" component={SoldOutPage} />}
                {isAdmin && <Route path="/business-closures" component={BusinessClosuresPage} />}
                <Redirect to="/" />
            </Switch>
            <Footer />
        </div>
    );
}

function App() {
    return (
        <AuthProvider>
            <BasketProvider>
                <BusinessStatusProvider>
                    <Router><AppRoutes /></Router>
                </BusinessStatusProvider>
            </BasketProvider>
        </AuthProvider>
    );
}

export default App;
